export const FETCH_ALL_PLAYERS = 'FETCH_ALL_PLAYERS';
export const FETCH_PLAYER = 'FETCH_PLAYER';
export const DELETE_PLAYER = 'DELETE_PLAYER';
export const ADD_FILTER = 'ADD_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';
export const RESET_PAGINATION = 'RESET_PAGINATION';
